import {
  effect,
  inject,
  Injectable,
  PLATFORM_ID,
  signal,
  WritableSignal,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export type AuthModalMode = 'login' | 'register' | 'forgot' | 'check-email';

/**
 * Estado global del modal de autenticación. El AuthModalComponent (montado
 * una única vez en el root layout) y el Header leen de aquí; los forms
 * cambian de modo vía `switchMode` sin desmontar el modal.
 *
 * Además bloquea el scroll del body mientras `isOpen()` es true, para que
 * cualquier trigger no tenga que preocuparse por ese efecto lateral.
 */
@Injectable({ providedIn: 'root' })
export class AuthModalService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  readonly isOpen: WritableSignal<boolean> = signal(false);
  readonly mode: WritableSignal<AuthModalMode> = signal<AuthModalMode>('login');
  readonly lastRegisteredEmail: WritableSignal<string | null> = signal<
    string | null
  >(null);

  constructor() {
    effect(() => {
      if (!this.isBrowser) return;
      const open = this.isOpen();
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  open(mode: AuthModalMode): void {
    this.mode.set(mode);
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
    this.mode.set('login');
    this.lastRegisteredEmail.set(null);
  }

  switchMode(mode: AuthModalMode): void {
    this.mode.set(mode);
  }

  openAfterRegister(email: string): void {
    this.lastRegisteredEmail.set(email);
    this.mode.set('check-email');
    this.isOpen.set(true);
  }
}
